import './MaintenanceInstructions.scss';

import React from 'react';
import { connect } from "react-redux";

import InstructionBuilder from './InstructionBuilder';
import TrustedContactInstructionContent from './content/TrustedContactInstructionContent';
import { AAMBeaconControl } from 'components/shared/Beacon';
import {getOnboardingMaintenanceOptOut} from 'state/onboardingMaintenance/OnboardingMaintenanceSelectors';
import Store from 'state/Store';
import { updateOnboardingMaintenanceOptOut } from 'state/onboardingMaintenance/OnboardingMaintenanceActions';

const TrustedContactInstructions = ({ onboardingMaintenanceOptOut }) => {
  const { optOut } = onboardingMaintenanceOptOut;
  const content = TrustedContactInstructionContent;
  return <div className="beacon-on-light">
    <InstructionBuilder content={content} />
    <AAMBeaconControl inline>
      <label slot="label" htmlFor="trusted-contacts-opt-out">I’m not interested</label>
      <input checked={optOut}
             type="checkbox"
             onChange={() => Store.dispatch(updateOnboardingMaintenanceOptOut('TRUSTED_CONTACT', !optOut))}/>
    </AAMBeaconControl>
  </div>
};

const mapStateToProps = (state) => ({
  onboardingMaintenanceOptOut: getOnboardingMaintenanceOptOut(state)
});

export default connect(mapStateToProps)(TrustedContactInstructions);
